import { Card, CardTitle, Separator } from '@repo/shadcn';

import { useCreateSupplier } from './create-supplier.hook';
import { CreateSupplierInitialValues } from './create-supplier.schema';
import { SupplierForm } from './form.component';

export const CreateSupplierModal = () => {
    const { onSubmit, isLoading } = useCreateSupplier();
    return (
        <Card className="border-none shadow-none">
            <CardTitle className="mb-2 text-[18px]">
                {' '}
                Create New Supplier
            </CardTitle>
            <Separator />
            <SupplierForm
                onSubmit={onSubmit}
                isLoading={isLoading}
                initialValues={CreateSupplierInitialValues}
            />
        </Card>
    );
};

CreateSupplierModal.displayName = 'CreateSupplierModal';
